import { render, staticRenderFns } from "./wtr-img.vue?vue&type=template&id=9da7f292&scoped=true&"
import script from "./wtr-img.vue?vue&type=script&lang=js&"
export * from "./wtr-img.vue?vue&type=script&lang=js&"
import style0 from "./wtr-img.vue?vue&type=style&index=0&id=9da7f292&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da7f292",
  null
  
)

export default component.exports